// API de Seguridad e Higiene (/api/seguridad). Instancia propia de axios: un 403 de este módulo no cierra la sesión.
// En local se apunta a un backend propio con REACT_APP_SEGURIDAD_API_URL (npm run seguridad:dev en lisual-admin-backend).
import axios from 'axios';

const BASE = process.env.REACT_APP_SEGURIDAD_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';
const api = axios.create({ baseURL: `${BASE.replace(/\/$/, '')}/api/seguridad`, timeout: 15000 });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errorSeguridad = (e) => e?.response?.data?.message || e?.message || 'Algo salió mal';

const f = (feedId) => encodeURIComponent(feedId);

export const getConfig = (feedId) => api.get(`/${f(feedId)}/config`).then((r) => r.data);
export const guardarConfig = (feedId, { zonasRiesgo, metaCasco, obligatorios }) => api.put(`/${f(feedId)}/config`, { zonasRiesgo, metaCasco, obligatorios }).then((r) => r.data);
export const getPersonas = (feedId, desde, hasta) => api.get(`/${f(feedId)}/personas`, { params: { desde, hasta } }).then((r) => r.data);
/** Personas y EPP verificados con Claude, por día ({ dias: [{ dia, fotos }] }). Máx. 31 días. */
export const getVerificado = (feedId, desde, hasta) => api.get(`/${f(feedId)}/verificado`, { params: { desde, hasta } }).then((r) => r.data);
/** Avanza la verificación de un día (un lote de fotos). Devuelve { total, hechas, pendientes, sinPresupuesto, sinClave }. */
export const verificarDia = (feedId, dia) => api.post(`/${f(feedId)}/verificar`, { dia }, { timeout: 300000 }).then((r) => r.data);
